import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export type StatusChipPropsType = {
  clickable?: boolean;
  icon?: React.ReactElement;
  size?: "small" | "medium";
  label?: React.ReactNode;
};

export default function StatusChip(props: StatusChipPropsType) {
  const { clickable, icon, size, label } = props;
  const theme = useTheme();

  return (
    <Chip
      clickable={clickable}
      size={size}
      icon={icon}
      label={label}
      sx={{
        m: "0 !important",
        height: 28,
        fontSize: 16,
        fontWeight: theme.typography.fontWeightBold,
        color: clickable ? theme.palette.primary.main : theme.palette.text.primary,
        bgcolor: clickable ? theme.palette.info.main : theme.palette.bg.dark,
        "&:hover": {
          bgcolor: clickable ? theme.palette.info.dark : theme.palette.bg.dark,
        },
        "&:focus": {
          bgcolor: clickable ? theme.palette.info.main : theme.palette.bg.dark,
        },
        ...(size === "small" && {
          height: theme.spacing(3),
          fontSize: 12,
          fontWeight: theme.typography.fontWeightMedium,
        }),
      }}
    />
  );
}
